import { useState } from "react";
import { X, CreditCard, CheckCircle, AlertCircle, ChevronDown } from "lucide-react";
import api from "../../axios"; // Axios instance

export default function PaymentConfirmationModal({ onClose, paymentDetails }) {
  const [isOpen, setIsOpen] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("paypal");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  


  const handleSubmit = async () => {
    setIsProcessing(true);
   

    try {

            // Now send to backend to get Paystack auth_url
        const payInitRes = await api.post('/paystack/initialize', {
            project_id: paymentDetails.projectId,
            amount: paymentDetails.amount,
            payment_type: paymentDetails.feeType,
            reference: paymentDetails.reference,
        });
    
        window.location.href = payInitRes.data.authorization_url;
        
    } catch (error) {
        console.error('Project creation or payment init failed:', error);
        alert('Project creation or payment init failed. Please try again.');

    }
    setIsProcessing(false);
    // setIsComplete(true);

  };

 
  const closeModal = () => {
    setIsOpen(false);
    onClose(); // Call the parent component's onClose function
  };
  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
    setShowDropdown(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="font-semibold text-lg text-gray-800">Payment Confirmation</h3>
          <button 
            onClick={closeModal}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-5">
          {!isComplete ? (
            <>
              {/* Payment Details */}
              <div className="mb-6">
                <h4 className="text-sm font-medium text-gray-500 mb-3">Payment Details</h4>
                <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Project</span>
                    <span className="text-sm font-medium text-gray-900">{paymentDetails.projectName}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Project ID</span>
                    <span className="text-sm font-medium text-gray-900">{paymentDetails.projectId}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Fee Type</span>
                    <span className="text-sm font-medium text-gray-900">
                        {paymentDetails.feeType === 'processing_fee' ? 'Processing Fee' : 'Approval Fee'}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Reference</span>
                    <span className="text-sm font-medium text-gray-900">{paymentDetails.reference}</span>
                  </div>
                  <div className="flex justify-between pt-2 border-t border-gray-200 mt-2">
                    <span className="text-sm font-medium text-gray-900">Total Amount</span>
                    <span className="text-lg font-bold text-blue-600">#{paymentDetails.amount.toFixed(2)}</span>
                  </div>
                </div>
              </div>

              {/* Payment Method */}
              <div className="mb-6" style={{ display: "none" }}>
                <h4 className="text-sm font-medium text-gray-500 mb-3">Payment Method</h4>
                <div className="relative">
                  <button 
                    className="w-full flex items-center justify-between px-4 py-3 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 transition-colors"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <div className="flex items-center space-x-3">
                      {paymentMethod === "credit-card" && (
                        <>
                          <CreditCard className="h-5 w-5 text-gray-500" />
                          <span className="text-sm font-medium text-gray-700">Credit Card</span>
                        </>
                      )}
                      {paymentMethod === "bank-transfer" && (
                        <>
                          <svg className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                          </svg>
                          <span className="text-sm font-medium text-gray-700">Bank Transfer</span>
                        </>
                      )}
                      {paymentMethod === "paypal" && (
                        <>
                          <svg className="h-5 w-5 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                          </svg>
                          <span className="text-sm font-medium text-gray-700">PayPal</span>
                        </>
                      )}
                    </div>
                    <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${showDropdown ? 'transform rotate-180' : ''}`} />
                  </button>

                  {showDropdown && (
                    <div className="absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                      <ul className="py-1">
                        <li>
                          <button 
                            className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center space-x-3"
                            onClick={() => handlePaymentMethodSelect("credit-card")}
                          >
                            <CreditCard className="h-5 w-5 text-gray-500" />
                            <span className="text-sm font-medium text-gray-700">Credit Card</span>
                          </button>
                        </li>
                        <li>
                          <button 
                            className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center space-x-3"
                            onClick={() => handlePaymentMethodSelect("bank-transfer")}
                          >
                            <svg className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                            </svg>
                            <span className="text-sm font-medium text-gray-700">Bank Transfer</span>
                          </button>
                        </li>
                        <li>
                          <button 
                            className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center space-x-3"
                            onClick={() => handlePaymentMethodSelect("paypal")}
                          >
                            <svg className="h-5 w-5 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            <span className="text-sm font-medium text-gray-700">PayPal</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                
                {/* Credit Card Form (shown only if credit card is selected) */}
                {paymentMethod === "credit-card" && (
                  <div className="mt-4 space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Card Number</label>
                      <input 
                        type="text" 
                        placeholder="1234 5678 9012 3456" 
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Expiry Date</label>
                        <input 
                          type="text" 
                          placeholder="MM/YY" 
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">CVC</label>
                        <input 
                          type="text" 
                          placeholder="123" 
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Name on Card</label>
                      <input 
                        type="text" 
                        placeholder="John Doe" 
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                )}
                
                {/* Bank transfer info */}
                {paymentMethod === "bank-transfer" && (
                  <div className="mt-4 p-4 bg-blue-50 border border-blue-100 rounded-lg">
                    <div className="flex items-start space-x-3">
                      <AlertCircle className="h-5 w-5 text-blue-500 mt-0.5" />
                      <div>
                        <h5 className="text-sm font-medium text-blue-800 mb-1">Bank Transfer Information</h5>
                        <p className="text-sm text-blue-700">Please use the following details to complete your payment:</p>
                        <div className="mt-3 space-y-1">
                          <p className="text-sm"><span className="font-medium">Bank Name:</span> Example National Bank</p>
                          <p className="text-sm"><span className="font-medium">Account Name:</span> Company XYZ</p>
                          <p className="text-sm"><span className="font-medium">Account Number:</span> 1234567890</p>
                          <p className="text-sm"><span className="font-medium">Sort Code/Routing:</span> 123456</p>
                          <p className="text-sm"><span className="font-medium">Reference:</span> {paymentDetails.reference}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Notes */}
              <div className="mb-6" style={{ display: "none" }}>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notes (Optional)</label>
                <textarea 
                  placeholder="Add any additional information..."
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  rows="2"
                ></textarea>
              </div>

              {/* Terms */}
              <div className="mb-6 flex items-start space-x-3">
                <input
                  type="checkbox"
                  id="terms"
                  className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor="terms" className="text-sm text-gray-600">
                  I agree to the <a href="#" className="text-blue-600 hover:text-blue-800">Terms and Conditions</a> and authorize this payment of ${paymentDetails.amount.toFixed(2)}.
                </label>
              </div>
            </>
          ) : (
            <div className="py-8 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
                <CheckCircle className="h-10 w-10 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Payment Successful</h3>
              <p className="text-gray-600 mb-6">
                Your payment of ${paymentDetails.amount.toFixed(2)} for the Processing Fee has been successfully processed.
              </p>
              <div className="bg-gray-50 rounded-lg px-4 py-3 mb-4">
                <p className="text-sm text-gray-600">
                  Payment Reference: <span className="font-medium">{paymentDetails.reference}</span>
                </p>
              </div>
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Return to Transactions
              </button>
            </div>
          )}
        </div>

        {/* Footer */}
        {!isComplete && (
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end">
            <div className="flex space-x-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isProcessing}
                className={`px-4 py-2 rounded-lg text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                  isProcessing 
                    ? 'bg-blue-400 cursor-not-allowed' 
                    : 'bg-blue-600 hover:bg-blue-700'
                }`}
              >
                {isProcessing ? (
                  <div className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                  </div>
                ) : (
                  'Confirm Payment'
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}